import React, { Fragment, useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { connect } from "react-redux";

import MakeAPICall from "../../apiCalls/common";
import APP_CONSTANTS from "../../constants";

import {
  // getConsultsApiRoute,
  getConsultDetailsApiRoute,
  unansweredCallsApiRoute,
  unansweredCallsFilterApiRoute,
  exportUnAnsweredConsultHistoryApiRoute,
  moveToPastConsultsApiRoute
} from "../../apiRoutes";

import {
  getFormattedDate,
  converToUtc,
  getFormattedTimeV2
} from "../../utils/dateTimeHelper";
import { sortData } from "../../utils/commonMethods";

import Loader from "../../components/loader";
import Button from "../../components/button";
import ICPhoneDisplay from "../../components/phoneDisplay";
import CustomDataTableSearchByFilter from "../../components/datatable/customDataTableSearchByFilter";
import CustomModal from "../../components/modal";
import DeviceDetails from "../../components/deviceDetails";

import searchFilterList from "../../constants/searchFilterList";

const UnansweredConsultsPage = props => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filter, setFilter] = useState(null);
  const [consultNatureFilter, setConsultNatureFilter] = useState(null);
  const [consultDurationFilter, setConsultDurationFilter] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  // const [apiCallParams1, setApiCallParams1] = useState(null);
  const [apiCallParams2, setApiCallParams2] = useState(null);
  const [currFilters, setCurrFilters] = useState({
    skip: 0,
    limit: 10
  });
  const [consults, setConsults] = useState([]);
  const [selMoveConsult, setSelMoveConsult] = useState(null);
  // const [consultNatureList, setConsultNatureList] = useState([]);
  const [consultDurationList, setConsultDurationList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");

  const tableHeaders = [
    {
      key: "patientId",
      value: "Patient UIN"
    },
    { key: "patientName", value: "Patient Name" },
    { key: "date", value: "Date" },
    { key: "time", value: "Time" },
    { key: "nature", value: "Nature of Consult" },
    { key: "deviceDetails", value: "Device Details" }
  ];

  // get consult nature list
  // const getConsultNatureList = () => {
  //   setApiCallParams1({
  //     reqType: "GET",
  //     reqUrl: getConsultsApiRoute,
  //     params: {
  //       skip: 0,
  //       limit: 0
  //     },
  //     successCallback: async res => {
  //       let list = [];
  //       await res.data.data.consultData.forEach(column => {
  //         let d = {};
  //         d._id = column._id;
  //         if (column.consultName && column.consultName !== "") {
  //           d.consultName = column.consultName;
  //         } else {
  //           d.consultName = "";
  //         }
  //         list.push(d);
  //       });
  //
  //       setConsultNatureList(list);
  //     },
  //     failureCallback: err => {
  //       // setErrModalText(
  //       //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
  //       // );
  //       // setShowErrModal(true);
  //     }
  //   });
  // };

  // get consult duration list
  const getConsultDurationList = () => {
    setApiCallParams2({
      reqType: "GET",
      reqUrl: getConsultDetailsApiRoute,
      params: {
        skip: 0,
        limit: 0
      },
      successCallback: async res => {
        let list = [];
        await res.data.data.consultDetailData.forEach(column => {
          let d = {};
          d._id = column._id;
          d.consultDuration =
            column.consultMode + " " + column.consultDuration + " Mins";
          list.push(d);
        });
        setConsultDurationList(list);
      },
      failureCallback: err => {
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // get consults
  const getConsults = () => {
    setIsProcessing(true);

    let apiUrl = unansweredCallsApiRoute;
    let params = Object.assign({}, currFilters);

    if (currFilters.text && currFilters.text.trim().length > 0) {
      apiUrl = unansweredCallsFilterApiRoute;
    } else {
      delete params.text;
      delete params.filterType;
    }

    setApiCallParams({
      reqType: "GET",
      reqUrl: apiUrl,
      params: params,
      successCallback: async res => {
        let list = [];
        await res.data.data.appointments.forEach(column => {
          let d = {};

          if (column.deviceDetails) {
            d.deviceDetails = column.deviceDetails;
          } else {
            d.deviceDetails = "";
          }

          d.appointmentId = column.appointmentId;

          if (column.patientId !== null) {
            d.patId = column.patientId._id;
            d.patientId = column.patientId.patientId;
            d.patientEmail = column.patientId.email;
            d.patientPhoneNo = column.patientId.phoneNumber;
            d.patientName = column.patientId.firstName;

            if (
              column.patientId.middleName !== "" ||
              column.patientId.middleName !== null ||
              column.patientId.middleName !== undefined ||
              column.patientId.middleName !== "undefined"
            ) {
              d.patientName = d.patientName + " " + column.patientId.middleName;
            }
            d.patientName = d.patientName + " " + column.patientId.lastName;
          } else {
            d.patId = "";
            d.patientId = "";
            d.patientEmail = "";
            d.patientPhoneNo = "";
            d.patientName = "";
          }

          d.date = getFormattedDate(column.createdAt);
          d.time = getFormattedTimeV2(column.createdAt);

          if (column.consultId) {
            d.nature = column.consultId.consultName;
          } else {
            d.nature = column.consultNature;
          }
          if (column.consultDetailId) {
            d.duration =
              column.consultDetailId.consultMode +
              " " +
              column.consultDetailId.consultDuration +
              " mins";
          } else {
            d.duration = "";
          }

          list.push(d);
        });
        setConsults(list);
        setTotalRecords(res.data.data.count);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // export consults
  const exportConsults = async () => {
    setIsProcessing(true);

    var formData = new FormData();
    formData.append("which", "unanswered");

    if (
      filter &&
      filter === "1" &&
      startDate !== null &&
      endDate !== null &&
      startDate <= endDate
    ) {
      formData.append("startDate", converToUtc(startDate));
      let dt = new Date(
        endDate.get("year"),
        endDate.get("month"),
        endDate.get("date") + 1,
        0,
        0,
        0
      ).toISOString();
      formData.append("endDate", converToUtc(dt));
    }

    await setApiCallParams({
      reqType: "POST",
      reqUrl: exportUnAnsweredConsultHistoryApiRoute,
      dataObj: formData,
      successCallback: async res => {
        setIsProcessing(false);
        var fileURL = res.data.data;
        var a = document.createElement("a");
        a.href = fileURL;
        a.target = "_blank";
        a.download = "Unanswered_Consults.csv";
        document.body.appendChild(a); //create the link "a"
        a.click(); //click the link "a"
        document.body.removeChild(a); //remove the link "a"
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // move to past consult
  const moveSelConsult = () => {
    setShowMoveModal(false);
    setIsProcessing(true);

    var formData = new FormData();
    formData.append("appointmentId", selMoveConsult.appointmentId);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: moveToPastConsultsApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setSelMoveConsult(null);
        getConsults();
        setErrModalText("Consult Moved Successfully");
        setShowErrModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        //setErrModalText(err.message);
        // setShowErrModal(true);
      }
    });
  };

  useEffect(() => {
    // if (consultNatureList.length === 0) {
    //   getConsultNatureList();
    // }

    if (consultDurationList.length === 0) {
      getConsultDurationList();
    }

    getConsults();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  const showSelMoveModal = item => {
    setSelMoveConsult(item);
    setShowMoveModal(true);
  };

  const hideSelMoveModal = () => {
    setShowMoveModal(false);
    setSelMoveConsult(null);
  };

  const handleFilterChange = event => {
    setFilter(event.target.value);
  };

  const handleStartDateChange = date => {
    setStartDate(date);
  };

  const handleEndDateChange = date => {
    setEndDate(date);
  };

  const handleConsultNatureFilterChange = e => {
    if (e.target.value === "0") {
      setConsultNatureFilter(null);
    } else {
      setConsultNatureFilter(e.target.value);
    }
  };

  const handleConsultDurationFilterChange = e => {
    if (e.target.value === "0") {
      setConsultDurationFilter(null);
    } else {
      setConsultDurationFilter(e.target.value);
    }
  };

  const clearFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setFilter(null);
    setConsultNatureFilter(null);
    setConsultDurationFilter(null);
    let newFilter = Object.assign({}, currFilters);
    if (newFilter.startDate) {
      delete newFilter.startDate;
    }
    if (newFilter.endDate) {
      delete newFilter.endDate;
    }
    if (newFilter.consultId) {
      delete newFilter.consultId;
    }
    if (newFilter.consultDetailId) {
      delete newFilter.consultDetailId;
    }
    setCurrFilters(newFilter);
  };

  const setTableFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.skip = filters.skip;
    newFilter.text = filters.text;
    newFilter.filterType = filters.filterType;

    setCurrFilters(newFilter);
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(SelColumn.column, SelColumn.order, consults);
    setConsults(sortedData);
  };

  const applySelectedFilter = () => {
    let newFilter = Object.assign({}, currFilters);

    if (newFilter.startDate) {
      delete newFilter.startDate;
    }
    if (newFilter.endDate) {
      delete newFilter.endDate;
    }
    if (newFilter.consultId) {
      delete newFilter.consultId;
    }
    if (newFilter.consultDetailId) {
      delete newFilter.consultDetailId;
    }

    if (
      filter === "1" &&
      startDate !== null &&
      endDate !== null &&
      startDate <= endDate
    ) {
      newFilter.startDate = converToUtc(startDate);
      let dt = new Date(
        endDate.get("year"),
        endDate.get("month"),
        endDate.get("date") + 1,
        0,
        0,
        0
      ).toISOString();
      newFilter.endDate = converToUtc(dt);
      setCurrFilters(newFilter);
    }

    if (filter === "2" && consultNatureFilter !== null) {
      newFilter.consultId = consultNatureFilter;
      setCurrFilters(newFilter);
    }

    if (filter === "3" && consultDurationFilter !== null) {
      newFilter.consultDetailId = consultDurationFilter;
      setCurrFilters(newFilter);
    }
  };

  const setSelectedPatient = pat => {
    const auth = props.auth.user;
    window.open(
      APP_CONSTANTS.pmsURL +
        "/patient/patientDetails?accessToken=" +
        auth.accessToken +
        "&patientId=" +
        pat.id +
        "&searchType=" +
        auth.userType +
        "&adminName=" +
        auth.firstName +
        " " +
        auth.lastName,
      "_blank"
    );
  };

  return (
    <Fragment>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="view-ticket-container">
          <CustomModal
            okayText="Confirm"
            cancelText="Cancel"
            openModal={showMoveModal}
            cancelEvent={hideSelMoveModal}
            okayEvent={moveSelConsult}
            modalBodyContent={
              <p className="text-center mb-0">Move to Past Consults?</p>
            }
          />
          <CustomModal
            useOneButton={true}
            cancelText="OKAY"
            openModal={showErrModal}
            cancelEvent={() => {
              setShowErrModal(false);
              setErrModalText("");
            }}
            modalBodyContent={
              <p className="text-center mb-0">{errModalText}</p>
            }
          />
          <h3>Unanswered Consults</h3>
          <div className="d-flex flex-row flex-wrap justify-content-between mt-4">
            <div></div>
            <div className="d-flex flex-row align-items-end">
              {filter === null && (
                <TextField
                  select
                  SelectProps={{
                    native: true
                  }}
                  onChange={handleFilterChange}
                >
                  <option>Select a Filter</option>
                  <option value="1">Filter by Date</option>
                  <option value="2">Filter by Nature of Consult</option>
                  {/* <option value="3">Filter by Duration of Consult</option> */}
                </TextField>
              )}
              {filter !== null && (
                <div className="d-flex flex-row align-items-end">
                  {filter === "1" && (
                    <div>
                      <KeyboardDatePicker
                        name="startDate"
                        style={{ width: "135px" }}
                        autoOk
                        variant="inline"
                        mask="__-__-____"
                        format="DD-MM-YYYY"
                        label="Start Date"
                        value={startDate}
                        onChange={date => handleStartDateChange(date)}
                      />
                      <KeyboardDatePicker
                        name="endDate"
                        style={{ width: "135px", marginLeft: "20px" }}
                        autoOk
                        variant="inline"
                        mask="__-__-____"
                        format="DD-MM-YYYY"
                        label="End Date"
                        value={endDate}
                        onChange={date => handleEndDateChange(date)}
                      />
                    </div>
                  )}
                  {filter === "2" && (
                    <TextField
                      select
                      SelectProps={{
                        native: true
                      }}
                      onChange={handleConsultNatureFilterChange}
                    >
                      <option value="0">Select Nature of Consult</option>
                      {props.consultNatureList.map((item, i) => (
                        <option key={i} value={item._id}>
                          {item.consultName}
                        </option>
                      ))}
                    </TextField>
                  )}
                  {filter === "3" && (
                    <TextField
                      select
                      SelectProps={{
                        native: true
                      }}
                      onChange={handleConsultDurationFilterChange}
                    >
                      <option value="0">Select Duration of Consult</option>
                      {consultDurationList.map((item, i) => (
                        <option key={i} value={item._id}>
                          {item.consultDuration}
                        </option>
                      ))}
                    </TextField>
                  )}

                  <button
                    style={{ minWidth: "30px", width: "30px" }}
                    className="insta-button-primary ml-3"
                    onClick={applySelectedFilter}
                  >
                    <i className="fas fa-arrow-right" aria-hidden="true"></i>
                  </button>
                  <button
                    style={{ minWidth: "30px", width: "30px" }}
                    className="insta-button-primary ic-btn-red ml-3"
                    onClick={clearFilter}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              )}
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Button
                clickEvent={exportConsults}
                title="Export to CSV"
              ></Button>
            </div>
          </div>
          <CustomDataTableSearchByFilter
            totalRecords={totalRecords}
            headers={tableHeaders}
            setFilters={setTableFilters}
            sortData={sortTableDataByColumn}
            tabFilters={currFilters}
            disbleAll={true}
            searchFilterList={
              searchFilterList.unansweredConsultSearchFilterList
            }
          >
            {consults.map((item, index) => (
              <tr
                key={index}
                onClick={() => {
                  showSelMoveModal(item);
                }}
              >
                <td
                  onClick={e => {
                    e.stopPropagation();
                    setSelectedPatient({
                      id: item.patId
                    });
                  }}
                >
                  {item.patientId}
                </td>
                <td>
                  <div className="d-flex flex-column position-relative">
                    <p className="mb-0">
                      <b>{item.patientName}</b>
                    </p>
                    <a
                      onClick={e => {
                        e.stopPropagation();
                      }}
                      className="high-z-index list-email"
                      href={"mailto:" + item.patientEmail}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.patientEmail}
                    </a>
                    <ICPhoneDisplay value={item.patientPhoneNo} />
                  </div>
                </td>
                <td>{item.date}</td>
                <td>{item.time}</td>
                <td>{item.nature}</td>
                <td>
                  <DeviceDetails data={item.deviceDetails} />
                </td>
              </tr>
            ))}
          </CustomDataTableSearchByFilter>
          {/* API Call */}
          <MakeAPICall apiParam={apiCallParams} />
          {/*<MakeAPICall apiParam={apiCallParams1} />*/}
          <MakeAPICall apiParam={apiCallParams2} />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
  consultNatureList: state.serverConstants.consultNatureList
});

export default connect(mapStateToProps, null)(UnansweredConsultsPage);
